import React, { FC } from 'react';
import { useTranslation } from 'react-i18next';
import ConfirmationDialog from 'components/orders/shared/confirmation-dialog.component';
import { currentOrgVar } from 'apollo/reactive-variables/organization';

type DeleteConstructionConfirmationDialogProps = {
    open: boolean;
    hasAddedMaterials: boolean;
    onCancel: () => void;
    onConfirm: () => void;
};

const DeleteConstructionConfirmationDialog: FC<DeleteConstructionConfirmationDialogProps> = ({
    open,
    hasAddedMaterials,
    onCancel,
    onConfirm,
}) => {
    const { t: translate } = useTranslation(['orders', 'common']);
    const currentOrg = currentOrgVar();

    const deleteInfoText = () => {
        if (!hasAddedMaterials) {
            return translate('orders:DELETE_CONSTRUCTION_INFO');
        }
        if (currentOrg?.type === 'lab') {
            return translate('orders:DELETE_CONSTRUCTION_WITH_MATERIALS_TECHNICIAN_INFO');
        }
        return translate('orders:DELETE_CONSTRUCTION_WITH_MATERIALS_DENTIST_INFO');
    };

    return (
        <ConfirmationDialog
            open={open}
            handleClose={onCancel}
            handleOk={onConfirm}
            title={translate('orders:DELETE_CONSTRUCTION')}
            confirm={translate('common:ARE_YOU_SURE')}
            process={translate('common:DELETE')}
            deleteInfoText={deleteInfoText()}
        />
    );
};

export default DeleteConstructionConfirmationDialog;
